import React from "react";
var __jsx = React.createElement;
var SearchSVG = function SearchSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#B7C0C9" : _ref$filledColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2039 11.9395L17.4879 16.3951C17.8503 16.7721 17.8383 17.3731 17.4617 17.7355C17.2844 17.9062 17.0509 18 16.8048 18C16.5447 18 16.302 17.8967 16.1216 17.7093L11.805 13.2199C10.5794 14.0812 9.14577 14.535 7.64139 14.535C3.63416 14.535 0.373901 11.2747 0.373901 7.26749C0.373901 3.26026 3.63416 0 7.64139 0C11.6486 0 14.9089 3.26026 14.9089 7.26749C14.9089 8.98262 14.3054 10.6301 13.2039 11.9395ZM13.013 7.26749C13.013 4.30552 10.6034 1.89587 7.64139 1.89587C4.67942 1.89587 2.26977 4.30552 2.26977 7.26749C2.26977 10.2295 4.67942 12.6391 7.64139 12.6391C10.6034 12.6391 13.013 10.2295 13.013 7.26749Z",
    fill: filledColor
  }));
};
export default SearchSVG;